import { BROWSER_ENUM, OS_ENUM } from '../configs'

const isIphoneWithSafari =
  window.navigator.userAgent.includes(OS_ENUM.IPHONE) && window.navigator.userAgent.includes(BROWSER_ENUM.SAFARI)
const isMacWithSafari =
  window.navigator.userAgent.includes(OS_ENUM.MAC) && window.navigator.userAgent.includes(BROWSER_ENUM.SAFARI)

export const NEED_EXTENDED_RANGE = isIphoneWithSafari || isMacWithSafari
export const MIN_GAP_BETWEEN_EVENTS = NEED_EXTENDED_RANGE ? 0.1 : 0.04

// WEB-2469 - show previous slide content on windows. Next slide start time increased , but keep maximum time for mac-related devices to 0.3, as they work perfectly
// result is 0.3 - for mac-related devices, 0.144 (minimal acceptable value to fix WEB-2469) vs previous 0.12 - for other devices
export const GAP_FOR_NAVIGATION_EVENTS = Math.min(MIN_GAP_BETWEEN_EVENTS * 3.6, 0.3)

export const RANGE_BOUND = NEED_EXTENDED_RANGE ? 0.1 : 0.04
export const TIMESHIFT_SLIDE_END_PLAY = RANGE_BOUND * 2
